export default function InvoicesTab() {
  return <p>Invoices tab coming soon.</p>;
}
